import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FunctionModel } from '@app/models/functioninfo/function.model';
import { FunctionLookupsModel } from '@app/models/functioninfo/functionlookup.model';
import { FunctionCategory } from '@app/models/functioninfo/functioncategory.model';
import { FunctionSummaryModel } from '@app/models/functioninfo/functionSummary.model';

@Injectable({ providedIn: "root" })
export class FunctionService {

  private service = 'api/FunctionService';
  public functionImageFileUploadService = this.service + '/upload';

  private functionOutputTypes = {
    FunctionName: "FunctionName",
    Discipline: "Discipline",
    TimeStamp: "TimeStamp",
    Constant: "Constant"
  };

  public cctvDesignerFunction: FunctionModel = {
    id: 97,
    name: 'CCTV Designer',
    imageName: 'Design Assistant.png',
    routePath: '/drawing-helper/drawing - helper',
    category: { id: 8, name: 'Design Tools' },
    pageTitle: 'CCTV Designer',
    pageSubtitle: '',
    isAdminOnly: false,
    functionCode: '',
    outputFileTypes: null
  };

  constructor(private httpClient: HttpClient) {

  }

  public getFunctionLookups(): Observable<FunctionLookupsModel> {
    return this.httpClient.get<FunctionLookupsModel>(`${this.service}/functionRouteLookup`);
  }

  public getSummaryList(): Observable<FunctionSummaryModel[]> {
    return this.httpClient.get<FunctionSummaryModel[]>(`${this.service}/summaryList`);
  }

  public getList(): Observable<FunctionModel[]> {
    return this.httpClient.get<FunctionModel[]>(`${this.service}/list`);
  }

  public getFunctionsAvailableToUser(): Observable<FunctionModel[]> {
    return this.httpClient.get<FunctionModel[]>(`${this.service}/listFunctionsAvailableToUser`);
  }
  public getFunctionsForComboAvailableToUser(): Observable<FunctionModel[]> {
    return this.httpClient.get<FunctionModel[]>(`${this.service}/listFunctionsForComboAvailableToUser`);
  }

  public deleteFunction(itemId: number) {
    return this.httpClient.delete(`${this.service}/delete/${itemId}`, { responseType: "json" });
  }

  public updateFunction(functionModel: FunctionModel) {
    return this.httpClient.post<any>(`${this.service}/update`, functionModel);
  }

  public addFunction(functionModel: FunctionModel): Observable<any> {
    return this.httpClient.post<any>(`${this.service}/add`, functionModel);
  }

  public addFunctionCategory(functionCategoryModel: FunctionCategory): Observable<FunctionCategory> {
    return this.httpClient.post<FunctionCategory>(`${this.service}/addCategory`, functionCategoryModel);
  }

  public listForHelp():any{
    return this.httpClient.get(`${this.service}/listForHelp`);
  }

  public getFunction(functionCatergory:FunctionCategory):any{
    return this.httpClient.post<string>(`${this.service}/getFunction`, functionCatergory);
  }
}
